module.exports = __webpack_public_path__ + "static/img/3-8.d069731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-8.jpg
// module id = Y/JO
// module chunks = 1